'use client'

import { useEffect } from 'react'

import Button from '@/components/atoms/Button/Button'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <>
      <title>Something went wrong</title>
      <meta name='robots' content='noindex' />
      <div className='flex min-h-[50dvh] items-center justify-center px-4 py-20'>
        <div className='max-w-lg text-center'>
          <h1 className='text-3xl font-bold sm:text-4xl lg:text-5xl'>Something went wrong</h1>
          <p className='mb-8 mt-4 text-text-secondary text-base sm:text-lg'>
            An unexpected error occurred. Please try again or return to the homepage.
          </p>
          <div className='flex flex-col items-center justify-center gap-4 sm:flex-row'>
            <Button noIcon onClick={() => reset()}>
              Try again
            </Button>
            <Button href='/'>Go to homepage</Button>
          </div>
        </div>
      </div>
    </>
  )
}
